<template>
  <b-card class="w-100">
    <div class="d-flex align-items-center justify-content-between w-100">
      <div
        class="col-xl-8 col-7 d-flex align-items-center justify-content-between py-50 px-50 rounded bg-secondary text-white"
      >
        <div
          class="user-select-all text-truncate"
          style="max-width: 90%"
          v-b-tooltip.hover="account.extra.name"
        >
          {{ account.mt_id }}
        </div>
        <feather-icon
          icon="CopyIcon"
          width="40px"
          class="ml-sm-75 cursor-pointer"
          v-b-tooltip.hover="'Copy address!'"
          @click="doCopy(account.mt_id)"
        />
      </div>
      <b-link
        v-if="account.editable"
        class="px-0 ml-50 cursor-pointer text-muted bg-secondary text-center py-50 px-50 rounded"
        style="white-space: nowrap"
        :to="{ name: 'accounts-edit', params: { id: account.id } }"
      >
        <feather-icon icon="EditIcon" v-b-tooltip.hover="'Edit'" />
        <small class="col-1 px-0"> Edit </small>
      </b-link>
      <b-form-group class="mb-0 px-0 ml-auto warning-button" v-if="account.editable">
        <b-form-checkbox
          v-model="active"
          name="active"
          class="mr-0 ml-50"
          switch
          inline
          :uncheckedValue="0"
          :value="1"
          @change="changeActive"
        >
        </b-form-checkbox>
      </b-form-group>
    </div>
    <div class="d-flex flex-nowrap align-items-center mt-1">
      <feather-icon icon="GitPullRequestIcon" size="20" />
      <div class="ml-25 d-flex flex-nowrap align-items-center">
        <span>Acount Name: </span>
        <span
          class="ml-25 font-weight-bolder cursor-pointer"
          v-b-tooltip.hover="account.username"
          >{{ account.username }}</span
        >
      </div>
    </div>
    <div class="d-flex flex-wrap align-items-start justify-content-between">
      <div class="col pl-0 d-flex p-0 mt-1" style="white-space: nowrap">
        <feather-icon icon="BarChart2Icon" size="20" />
        <div class="ml-25 align-items-center">
          <span>Balance : </span>
          <span
            class="ml-25 font-weight-bolder cursor-pointer"
            v-b-tooltip.hover="account.extra.balance"
            >{{ account.extra.balance }} $</span
          >
        </div>
      </div>
      <div class="col d-flex flex-nowrap p-0 mt-1" style="white-space: nowrap">
        <feather-icon icon="BarChartIcon" size="20" />
        <div class="ml-25 align-items-center">
          <span>Equity : </span>
          <span
            class="ml-25 font-weight-bolder cursor-pointer"
            v-b-tooltip.hover="account.extra.equity"
            >{{ account.extra.equity }} $</span
          >
        </div>
      </div>
    </div>
    <div class="d-flex flex-wrap align-items-start justify-content-between">
      <div class="col p-0 d-flex mt-1" style="white-space: nowrap">
        <feather-icon icon="AwardIcon" size="20" />
        <div class="ml-25 align-items-center">
          <span>Competition : </span>
          <span
            class="ml-25 font-weight-bolder cursor-pointer"
            v-b-tooltip.hover="
              account.competitions &&
              account.competitions.data[0] &&
              account.competitions.data[0].name
                ? account.competitions.data[0].name
                : '-'
            "
            >{{
              account.competitions &&
              account.competitions.data[0] &&
              account.competitions.data[0].name
                ? account.competitions.data[0].name
                : "-"
            }}</span
          >
        </div>
      </div>
      <div class="col d-flex p-0 mt-1" style="white-space: nowrap">
        <feather-icon icon="CodepenIcon" size="20" />
        <div class="ml-25 align-items-center">
          <span>Broker : </span>
          <span
            class="ml-25 font-weight-bolder cursor-pointer"
            v-b-tooltip.hover="account.broker.data.name"
            >{{ account.broker.data.name }}</span
          >
        </div>
      </div>
    </div>

    <div
      class="d-flex align-items-center justify-content-between mt-1"
      style="white-space: nowrap"
    >
      <div class="d-flex align-items-center">
        <template v-if="account.active">
          <div
            :class="[
              is_connected ? 'bg-success' : 'bg-secondary',
              'rounded-circle',
            ]"
            style="width: 10px; height: 10px"
          ></div>
          <div
            :class="[
              is_connected ? 'bg-secondary' : 'bg-danger',
              'rounded-circle ml-25',
            ]"
            style="width: 10px; height: 10px"
          ></div>
          <span
            class="font-weight-bolder cursor-pointer"
            v-b-tooltip.hover="is_connected ? 'Connected' : 'Disconnected'"
            >{{ is_connected ? "Connected" : "Disconnected" }}</span
          >
          <feather-icon
            v-if="!is_connected"
            icon="AlertTriangleIcon"
            size="18"
            class="ml-25 text-warning cursor-pointer"
            v-b-tooltip.hover.v-warning="'Disconnected'"
          />
        </template>
        <template v-else>
          <feather-icon
            icon="PauseIcon"
            size="18"
            class="text-danger cursor-pointer"
            v-b-tooltip.hover.v-danger="'Disabled'"
          />
          <span class="ml-1 font-weight-bolder cursor-pointer"> Disabled </span>
        </template>
      </div>
    </div>
    <br class="d-md-none d-block" />
    <br class="d-md-none d-block" />

    <div
      v-if="$store.state.auth.userData.type === 'admin'"
      class="position-absolute"
      style="right: 13px; bottom: 13px"
    >
      <b-button
        class="p-75 hover-info"
        size="sm"
        @click="$emit('openOrder', account.id)"
        >Open Orders</b-button
      >
      <b-button
        class="p-75 ml-50 hover-primary"
        size="sm"
        @click="$emit('openHistory', account.id)"
        >Order History</b-button
      >
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  VBTooltip,
  BFormCheckbox,
  BFormGroup,
  BLink,
  BButton,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BCard,
    BFormCheckbox,
    BFormGroup,
    BLink,
    BButton,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    account: {
      type: Object,
      default: () => {},
    },
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      is_connected: false,
      active: 0,
    };
  },
  watch: {
    account: {
      handler(val) {
        this.is_connected = val.connectivity;
      },
      deep: true,
    },
  },

  async created() {
    this.active = this.account.active ? 1 : 0;
    if (this.active) {
      await this.getConnectivity(this.account.id);
    }
    this.$emit("allExtra", this.account.id);
  },
  methods: {
    async changeActive() {
      try {
        const { data } = await this.$http.post(
          `panel/accounts/${this.account.id}/active?_method=patch`
        );
        this.$emit("updateAccounts");
      } catch (err) {}
    },
    async getConnectivity(id) {
      try {
        const { data } = await this.$http.get(
          `/panel/accounts/${id}/connectivity`
        );
        this.is_connected = data.is_connected;
      } catch (err) {}
    },
    doCopy(id) {
      this.$copyText(id).then(
        () => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Text copied",
              icon: "BellIcon",
            },
          });
        },
        (e) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Can not copy!",
              icon: "BellIcon",
            },
          });
        }
      );
    },
  },
};
</script>

<style></style>
